/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { ApiMessage } from './ApiMessage';
import {
    ApiMessageFromJSON,
    ApiMessageFromJSONTyped,
    ApiMessageToJSON,
} from './ApiMessage';
import type { AvailableOperation } from './AvailableOperation';
import {
    AvailableOperationFromJSON,
    AvailableOperationFromJSONTyped,
    AvailableOperationToJSON,
} from './AvailableOperation';
import type { B2BCostCenter } from './B2BCostCenter';
import {
    B2BCostCenterFromJSON,
    B2BCostCenterFromJSONTyped,
    B2BCostCenterToJSON,
} from './B2BCostCenter';
import type { B2BPaymentType } from './B2BPaymentType';
import {
    B2BPaymentTypeFromJSON,
    B2BPaymentTypeFromJSONTyped,
    B2BPaymentTypeToJSON,
} from './B2BPaymentType';
import type { DeliveryMode } from './DeliveryMode';
import {
    DeliveryModeFromJSON,
    DeliveryModeFromJSONTyped,
    DeliveryModeToJSON,
} from './DeliveryMode';
import type { DeliveryOrderEntryGroup } from './DeliveryOrderEntryGroup';
import {
    DeliveryOrderEntryGroupFromJSON,
    DeliveryOrderEntryGroupFromJSONTyped,
    DeliveryOrderEntryGroupToJSON,
} from './DeliveryOrderEntryGroup';
import type { EntryGroup } from './EntryGroup';
import {
    EntryGroupFromJSON,
    EntryGroupFromJSONTyped,
    EntryGroupToJSON,
} from './EntryGroup';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';
import type { PaymentDetails } from './PaymentDetails';
import {
    PaymentDetailsFromJSON,
    PaymentDetailsFromJSONTyped,
    PaymentDetailsToJSON,
} from './PaymentDetails';
import type { PaymentMode } from './PaymentMode';
import {
    PaymentModeFromJSON,
    PaymentModeFromJSONTyped,
    PaymentModeToJSON,
} from './PaymentMode';
import type { PickupOrderEntryGroup } from './PickupOrderEntryGroup';
import {
    PickupOrderEntryGroupFromJSON,
    PickupOrderEntryGroupFromJSONTyped,
    PickupOrderEntryGroupToJSON,
} from './PickupOrderEntryGroup';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Principal } from './Principal';
import {
    PrincipalFromJSON,
    PrincipalFromJSONTyped,
    PrincipalToJSON,
} from './Principal';
import type { PromotionResult } from './PromotionResult';
import {
    PromotionResultFromJSON,
    PromotionResultFromJSONTyped,
    PromotionResultToJSON,
} from './PromotionResult';
import type { Quote } from './Quote';
import {
    QuoteFromJSON,
    QuoteFromJSONTyped,
    QuoteToJSON,
} from './Quote';
import type { SAPAdditionalCostValue } from './SAPAdditionalCostValue';
import {
    SAPAdditionalCostValueFromJSON,
    SAPAdditionalCostValueFromJSONTyped,
    SAPAdditionalCostValueToJSON,
} from './SAPAdditionalCostValue';
import type { SAPAdditionalTotal } from './SAPAdditionalTotal';
import {
    SAPAdditionalTotalFromJSON,
    SAPAdditionalTotalFromJSONTyped,
    SAPAdditionalTotalToJSON,
} from './SAPAdditionalTotal';
import type { SAPCalculationStatus } from './SAPCalculationStatus';
import {
    SAPCalculationStatusFromJSON,
    SAPCalculationStatusFromJSONTyped,
    SAPCalculationStatusToJSON,
} from './SAPCalculationStatus';
import type { SAPDiscountSummary } from './SAPDiscountSummary';
import {
    SAPDiscountSummaryFromJSON,
    SAPDiscountSummaryFromJSONTyped,
    SAPDiscountSummaryToJSON,
} from './SAPDiscountSummary';
import type { SAPFiscalId } from './SAPFiscalId';
import {
    SAPFiscalIdFromJSON,
    SAPFiscalIdFromJSONTyped,
    SAPFiscalIdToJSON,
} from './SAPFiscalId';
import type { SAPGiftCard } from './SAPGiftCard';
import {
    SAPGiftCardFromJSON,
    SAPGiftCardFromJSONTyped,
    SAPGiftCardToJSON,
} from './SAPGiftCard';
import type { SAPGiftCardSummary } from './SAPGiftCardSummary';
import {
    SAPGiftCardSummaryFromJSON,
    SAPGiftCardSummaryFromJSONTyped,
    SAPGiftCardSummaryToJSON,
} from './SAPGiftCardSummary';
import type { Trigger } from './Trigger';
import {
    TriggerFromJSON,
    TriggerFromJSONTyped,
    TriggerToJSON,
} from './Trigger';
import type { Voucher } from './Voucher';
import {
    VoucherFromJSON,
    VoucherFromJSONTyped,
    VoucherToJSON,
} from './Voucher';

/**
 * Request body fields required and optional to operate on Replenishment Order data.
 * @export
 * @interface ReplenishmentOrder
 */
export interface ReplenishmentOrder {
    /**
     * Code number of order
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    code?: string;
    /**
     * Flag stating iv value is net-value
     * @type {boolean}
     * @memberof ReplenishmentOrder
     */
    net?: boolean;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    totalPriceWithTax?: Price;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    totalPrice?: Price;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    totalTax?: Price;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    subTotal?: Price;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    deliveryCost?: Price;
    /**
     * List of order entries
     * @type {Array<OrderEntry>}
     * @memberof ReplenishmentOrder
     */
    entries?: Array<OrderEntry>;
    /**
     * List of entry groups
     * @type {Array<EntryGroup>}
     * @memberof ReplenishmentOrder
     */
    entryGroups?: Array<EntryGroup>;
    /**
     * 
     * @type {number}
     * @memberof ReplenishmentOrder
     */
    totalItems?: number;
    /**
     * 
     * @type {DeliveryMode}
     * @memberof ReplenishmentOrder
     */
    deliveryMode?: DeliveryMode;
    /**
     * 
     * @type {Address}
     * @memberof ReplenishmentOrder
     */
    deliveryAddress?: Address;
    /**
     * 
     * @type {PaymentDetails}
     * @memberof ReplenishmentOrder
     */
    paymentInfo?: PaymentDetails;
    /**
     * List of applied order promotions
     * @type {Array<PromotionResult>}
     * @memberof ReplenishmentOrder
     */
    appliedOrderPromotions?: Array<PromotionResult>;
    /**
     * List of applied product promotions
     * @type {Array<PromotionResult>}
     * @memberof ReplenishmentOrder
     */
    appliedProductPromotions?: Array<PromotionResult>;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    productDiscounts?: Price;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    orderDiscounts?: Price;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    totalDiscounts?: Price;
    /**
     * Site
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    site?: string;
    /**
     * Store
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    store?: string;
    /**
     * Guest user id identifier
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    guid?: string;
    /**
     * Flag showing if order is calculated
     * @type {boolean}
     * @memberof ReplenishmentOrder
     */
    calculated?: boolean;
    /**
     * List of applied vouchers
     * @type {Array<Voucher>}
     * @memberof ReplenishmentOrder
     */
    appliedVouchers?: Array<Voucher>;
    /**
     * 
     * @type {Principal}
     * @memberof ReplenishmentOrder
     */
    user?: Principal;
    /**
     * List of pickup order entry group
     * @type {Array<PickupOrderEntryGroup>}
     * @memberof ReplenishmentOrder
     */
    pickupOrderGroups?: Array<PickupOrderEntryGroup>;
    /**
     * List of delivery order entries group
     * @type {Array<DeliveryOrderEntryGroup>}
     * @memberof ReplenishmentOrder
     */
    deliveryOrderGroups?: Array<DeliveryOrderEntryGroup>;
    /**
     * Quantity of pickup items
     * @type {number}
     * @memberof ReplenishmentOrder
     */
    pickupItemsQuantity?: number;
    /**
     * Quantity of delivery items
     * @type {number}
     * @memberof ReplenishmentOrder
     */
    deliveryItemsQuantity?: number;
    /**
     * Customer requested date for order retrieval
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    requestedRetrievalAt?: string;
    /**
     * 
     * @type {Address}
     * @memberof ReplenishmentOrder
     */
    sapBillingAddress?: Address;
    /**
     * Email of customer.
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    sapCustomerEmail?: string;
    /**
     * The payment option identifier. It specifies which option the consumer selected to make the payment for the cart.
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    sapPaymentOptionId?: string;
    /**
     * 
     * @type {B2BPaymentType}
     * @memberof ReplenishmentOrder
     */
    paymentType?: B2BPaymentType;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    purchaseOrderNumber?: string;
    /**
     * List of gift cards applied to the cart.
     * @type {Array<SAPGiftCard>}
     * @memberof ReplenishmentOrder
     */
    sapGiftCards?: Array<SAPGiftCard>;
    /**
     * 
     * @type {SAPGiftCardSummary}
     * @memberof ReplenishmentOrder
     */
    sapGiftCardSummary?: SAPGiftCardSummary;
    /**
     * 
     * @type {SAPCalculationStatus}
     * @memberof ReplenishmentOrder
     */
    sapCalculationStatus?: SAPCalculationStatus;
    /**
     * Optionally, services can provide specific summaries of prices, costs and/or taxes, to be displayed to the customer. Those do not affect the Commerce order total. Null when not available.
     * @type {Array<SAPAdditionalTotal>}
     * @memberof ReplenishmentOrder
     */
    sapAdditionalTotals?: Array<SAPAdditionalTotal>;
    /**
     * Optionally, services can provide specific discount summaries, to be displayed to the customer. Those do not affect the Commerce order total. Null when not available.
     * @type {Array<SAPDiscountSummary>}
     * @memberof ReplenishmentOrder
     */
    sapDiscountSummaries?: Array<SAPDiscountSummary>;
    /**
     * Additional costs of sales, e.g. DELIVERY, PAYMENT, INSURANCE, HANDLING etc. Null when not available.
     * @type {Array<SAPAdditionalCostValue>}
     * @memberof ReplenishmentOrder
     */
    sapAdditionalCostValues?: Array<SAPAdditionalCostValue>;
    /**
     * 
     * @type {SAPFiscalId}
     * @memberof ReplenishmentOrder
     */
    sapCustomerFiscalId?: SAPFiscalId;
    /**
     * 
     * @type {Price}
     * @memberof ReplenishmentOrder
     */
    totalOrderDiscounts?: Price;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    pakkeboksId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    rekvisition?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    entryCode?: string;
    /**
     * 
     * @type {PaymentMode}
     * @memberof ReplenishmentOrder
     */
    paymentMode?: PaymentMode;
    /**
     * 
     * @type {Address}
     * @memberof ReplenishmentOrder
     */
    paymentAddress?: Address;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    flexDeliveryComment1?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    flexDeliveryComment2?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    actingUserId?: string;
    /**
     * Total unit count
     * @type {number}
     * @memberof ReplenishmentOrder
     */
    totalUnitCount?: number;
    /**
     * List of potential order promotions for cart
     * @type {Array<PromotionResult>}
     * @memberof ReplenishmentOrder
     */
    potentialOrderPromotions?: Array<PromotionResult>;
    /**
     * List of potential product promotions for cart
     * @type {Array<PromotionResult>}
     * @memberof ReplenishmentOrder
     */
    potentialProductPromotions?: Array<PromotionResult>;
    /**
     * Name of the cart
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    name?: string;
    /**
     * Description of the cart
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    description?: string;
    /**
     * Date of cart expiration time
     * @type {Date}
     * @memberof ReplenishmentOrder
     */
    expirationTime?: Date;
    /**
     * Date of saving cart
     * @type {Date}
     * @memberof ReplenishmentOrder
     */
    saveTime?: Date;
    /**
     * 
     * @type {Principal}
     * @memberof ReplenishmentOrder
     */
    savedBy?: Principal;
    /**
     * Earliest possible retrieval date available for order
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    earliestRetrievalAt?: string;
    /**
     * Messages about supplementary info, warning messages related to the cart
     * @type {Array<ApiMessage>}
     * @memberof ReplenishmentOrder
     */
    messages?: Array<ApiMessage>;
    /**
     * Available operations determined by the operation identifiers and the values defined in the AvailableOperation schemas. For the cart, the supported operation is applyGiftCard.
     * @type {{ [key: string]: AvailableOperation; }}
     * @memberof ReplenishmentOrder
     */
    availableOperations?: { [key: string]: AvailableOperation; };
    /**
     * 
     * @type {B2BCostCenter}
     * @memberof ReplenishmentOrder
     */
    costCenter?: B2BCostCenter;
    /**
     * 
     * @type {Quote}
     * @memberof ReplenishmentOrder
     */
    sapQuote?: Quote;
    /**
     * Is the Replenishment Order active
     * @type {boolean}
     * @memberof ReplenishmentOrder
     */
    active?: boolean;
    /**
     * 
     * @type {Trigger}
     * @memberof ReplenishmentOrder
     */
    trigger?: Trigger;
    /**
     * First date of the replenishment order
     * @type {Date}
     * @memberof ReplenishmentOrder
     */
    firstDate?: Date;
    /**
     * Unique code for the replenishment order
     * @type {string}
     * @memberof ReplenishmentOrder
     */
    replenishmentOrderCode: string;
}

/**
 * Check if a given object implements the ReplenishmentOrder interface.
 */
export function instanceOfReplenishmentOrder(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "replenishmentOrderCode" in value;

    return isInstance;
}

export function ReplenishmentOrderFromJSON(json: any): ReplenishmentOrder {
    return ReplenishmentOrderFromJSONTyped(json, false);
}

export function ReplenishmentOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplenishmentOrder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'net': !exists(json, 'net') ? undefined : json['net'],
        'totalPriceWithTax': !exists(json, 'totalPriceWithTax') ? undefined : PriceFromJSON(json['totalPriceWithTax']),
        'totalPrice': !exists(json, 'totalPrice') ? undefined : PriceFromJSON(json['totalPrice']),
        'totalTax': !exists(json, 'totalTax') ? undefined : PriceFromJSON(json['totalTax']),
        'subTotal': !exists(json, 'subTotal') ? undefined : PriceFromJSON(json['subTotal']),
        'deliveryCost': !exists(json, 'deliveryCost') ? undefined : PriceFromJSON(json['deliveryCost']),
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(OrderEntryFromJSON)),
        'entryGroups': !exists(json, 'entryGroups') ? undefined : ((json['entryGroups'] as Array<any>).map(EntryGroupFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
        'deliveryMode': !exists(json, 'deliveryMode') ? undefined : DeliveryModeFromJSON(json['deliveryMode']),
        'deliveryAddress': !exists(json, 'deliveryAddress') ? undefined : AddressFromJSON(json['deliveryAddress']),
        'paymentInfo': !exists(json, 'paymentInfo') ? undefined : PaymentDetailsFromJSON(json['paymentInfo']),
        'appliedOrderPromotions': !exists(json, 'appliedOrderPromotions') ? undefined : ((json['appliedOrderPromotions'] as Array<any>).map(PromotionResultFromJSON)),
        'appliedProductPromotions': !exists(json, 'appliedProductPromotions') ? undefined : ((json['appliedProductPromotions'] as Array<any>).map(PromotionResultFromJSON)),
        'productDiscounts': !exists(json, 'productDiscounts') ? undefined : PriceFromJSON(json['productDiscounts']),
        'orderDiscounts': !exists(json, 'orderDiscounts') ? undefined : PriceFromJSON(json['orderDiscounts']),
        'totalDiscounts': !exists(json, 'totalDiscounts') ? undefined : PriceFromJSON(json['totalDiscounts']),
        'site': !exists(json, 'site') ? undefined : json['site'],
        'store': !exists(json, 'store') ? undefined : json['store'],
        'guid': !exists(json, 'guid') ? undefined : json['guid'],
        'calculated': !exists(json, 'calculated') ? undefined : json['calculated'],
        'appliedVouchers': !exists(json, 'appliedVouchers') ? undefined : ((json['appliedVouchers'] as Array<any>).map(VoucherFromJSON)),
        'user': !exists(json, 'user') ? undefined : PrincipalFromJSON(json['user']),
        'pickupOrderGroups': !exists(json, 'pickupOrderGroups') ? undefined : ((json['pickupOrderGroups'] as Array<any>).map(PickupOrderEntryGroupFromJSON)),
        'deliveryOrderGroups': !exists(json, 'deliveryOrderGroups') ? undefined : ((json['deliveryOrderGroups'] as Array<any>).map(DeliveryOrderEntryGroupFromJSON)),
        'pickupItemsQuantity': !exists(json, 'pickupItemsQuantity') ? undefined : json['pickupItemsQuantity'],
        'deliveryItemsQuantity': !exists(json, 'deliveryItemsQuantity') ? undefined : json['deliveryItemsQuantity'],
        'requestedRetrievalAt': !exists(json, 'requestedRetrievalAt') ? undefined : json['requestedRetrievalAt'],
        'sapBillingAddress': !exists(json, 'sapBillingAddress') ? undefined : AddressFromJSON(json['sapBillingAddress']),
        'sapCustomerEmail': !exists(json, 'sapCustomerEmail') ? undefined : json['sapCustomerEmail'],
        'sapPaymentOptionId': !exists(json, 'sapPaymentOptionId') ? undefined : json['sapPaymentOptionId'],
        'paymentType': !exists(json, 'paymentType') ? undefined : B2BPaymentTypeFromJSON(json['paymentType']),
        'purchaseOrderNumber': !exists(json, 'purchaseOrderNumber') ? undefined : json['purchaseOrderNumber'],
        'sapGiftCards': !exists(json, 'sapGiftCards') ? undefined : ((json['sapGiftCards'] as Array<any>).map(SAPGiftCardFromJSON)),
        'sapGiftCardSummary': !exists(json, 'sapGiftCardSummary') ? undefined : SAPGiftCardSummaryFromJSON(json['sapGiftCardSummary']),
        'sapCalculationStatus': !exists(json, 'sapCalculationStatus') ? undefined : SAPCalculationStatusFromJSON(json['sapCalculationStatus']),
        'sapAdditionalTotals': !exists(json, 'sapAdditionalTotals') ? undefined : ((json['sapAdditionalTotals'] as Array<any>).map(SAPAdditionalTotalFromJSON)),
        'sapDiscountSummaries': !exists(json, 'sapDiscountSummaries') ? undefined : ((json['sapDiscountSummaries'] as Array<any>).map(SAPDiscountSummaryFromJSON)),
        'sapAdditionalCostValues': !exists(json, 'sapAdditionalCostValues') ? undefined : ((json['sapAdditionalCostValues'] as Array<any>).map(SAPAdditionalCostValueFromJSON)),
        'sapCustomerFiscalId': !exists(json, 'sapCustomerFiscalId') ? undefined : SAPFiscalIdFromJSON(json['sapCustomerFiscalId']),
        'totalOrderDiscounts': !exists(json, 'totalOrderDiscounts') ? undefined : PriceFromJSON(json['totalOrderDiscounts']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'pakkeboksId': !exists(json, 'pakkeboksId') ? undefined : json['pakkeboksId'],
        'rekvisition': !exists(json, 'rekvisition') ? undefined : json['rekvisition'],
        'entryCode': !exists(json, 'entryCode') ? undefined : json['entryCode'],
        'paymentMode': !exists(json, 'paymentMode') ? undefined : PaymentModeFromJSON(json['paymentMode']),
        'paymentAddress': !exists(json, 'paymentAddress') ? undefined : AddressFromJSON(json['paymentAddress']),
        'flexDeliveryComment1': !exists(json, 'flexDeliveryComment1') ? undefined : json['flexDeliveryComment1'],
        'flexDeliveryComment2': !exists(json, 'flexDeliveryComment2') ? undefined : json['flexDeliveryComment2'],
        'actingUserId': !exists(json, 'actingUserId') ? undefined : json['actingUserId'],
        'totalUnitCount': !exists(json, 'totalUnitCount') ? undefined : json['totalUnitCount'],
        'potentialOrderPromotions': !exists(json, 'potentialOrderPromotions') ? undefined : ((json['potentialOrderPromotions'] as Array<any>).map(PromotionResultFromJSON)),
        'potentialProductPromotions': !exists(json, 'potentialProductPromotions') ? undefined : ((json['potentialProductPromotions'] as Array<any>).map(PromotionResultFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'expirationTime': !exists(json, 'expirationTime') ? undefined : (new Date(json['expirationTime'])),
        'saveTime': !exists(json, 'saveTime') ? undefined : (new Date(json['saveTime'])),
        'savedBy': !exists(json, 'savedBy') ? undefined : PrincipalFromJSON(json['savedBy']),
        'earliestRetrievalAt': !exists(json, 'earliestRetrievalAt') ? undefined : json['earliestRetrievalAt'],
        'messages': !exists(json, '_messages') ? undefined : ((json['_messages'] as Array<any>).map(ApiMessageFromJSON)),
        'availableOperations': !exists(json, '_availableOperations') ? undefined : (mapValues(json['_availableOperations'], AvailableOperationFromJSON)),
        'costCenter': !exists(json, 'costCenter') ? undefined : B2BCostCenterFromJSON(json['costCenter']),
        'sapQuote': !exists(json, 'sapQuote') ? undefined : QuoteFromJSON(json['sapQuote']),
        'active': !exists(json, 'active') ? undefined : json['active'],
        'trigger': !exists(json, 'trigger') ? undefined : TriggerFromJSON(json['trigger']),
        'firstDate': !exists(json, 'firstDate') ? undefined : (new Date(json['firstDate'])),
        'replenishmentOrderCode': json['replenishmentOrderCode'],
    };
}

export function ReplenishmentOrderToJSON(value?: ReplenishmentOrder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'net': value.net,
        'totalPriceWithTax': PriceToJSON(value.totalPriceWithTax),
        'totalPrice': PriceToJSON(value.totalPrice),
        'totalTax': PriceToJSON(value.totalTax),
        'subTotal': PriceToJSON(value.subTotal),
        'deliveryCost': PriceToJSON(value.deliveryCost),
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(OrderEntryToJSON)),
        'entryGroups': value.entryGroups === undefined ? undefined : ((value.entryGroups as Array<any>).map(EntryGroupToJSON)),
        'totalItems': value.totalItems,
        'deliveryMode': DeliveryModeToJSON(value.deliveryMode),
        'deliveryAddress': AddressToJSON(value.deliveryAddress),
        'paymentInfo': PaymentDetailsToJSON(value.paymentInfo),
        'appliedOrderPromotions': value.appliedOrderPromotions === undefined ? undefined : ((value.appliedOrderPromotions as Array<any>).map(PromotionResultToJSON)),
        'appliedProductPromotions': value.appliedProductPromotions === undefined ? undefined : ((value.appliedProductPromotions as Array<any>).map(PromotionResultToJSON)),
        'productDiscounts': PriceToJSON(value.productDiscounts),
        'orderDiscounts': PriceToJSON(value.orderDiscounts),
        'totalDiscounts': PriceToJSON(value.totalDiscounts),
        'site': value.site,
        'store': value.store,
        'guid': value.guid,
        'calculated': value.calculated,
        'appliedVouchers': value.appliedVouchers === undefined ? undefined : ((value.appliedVouchers as Array<any>).map(VoucherToJSON)),
        'user': PrincipalToJSON(value.user),
        'pickupOrderGroups': value.pickupOrderGroups === undefined ? undefined : ((value.pickupOrderGroups as Array<any>).map(PickupOrderEntryGroupToJSON)),
        'deliveryOrderGroups': value.deliveryOrderGroups === undefined ? undefined : ((value.deliveryOrderGroups as Array<any>).map(DeliveryOrderEntryGroupToJSON)),
        'pickupItemsQuantity': value.pickupItemsQuantity,
        'deliveryItemsQuantity': value.deliveryItemsQuantity,
        'requestedRetrievalAt': value.requestedRetrievalAt,
        'sapBillingAddress': AddressToJSON(value.sapBillingAddress),
        'sapCustomerEmail': value.sapCustomerEmail,
        'sapPaymentOptionId': value.sapPaymentOptionId,
        'paymentType': B2BPaymentTypeToJSON(value.paymentType),
        'purchaseOrderNumber': value.purchaseOrderNumber,
        'sapGiftCards': value.sapGiftCards === undefined ? undefined : ((value.sapGiftCards as Array<any>).map(SAPGiftCardToJSON)),
        'sapGiftCardSummary': SAPGiftCardSummaryToJSON(value.sapGiftCardSummary),
        'sapCalculationStatus': SAPCalculationStatusToJSON(value.sapCalculationStatus),
        'sapAdditionalTotals': value.sapAdditionalTotals === undefined ? undefined : ((value.sapAdditionalTotals as Array<any>).map(SAPAdditionalTotalToJSON)),
        'sapDiscountSummaries': value.sapDiscountSummaries === undefined ? undefined : ((value.sapDiscountSummaries as Array<any>).map(SAPDiscountSummaryToJSON)),
        'sapAdditionalCostValues': value.sapAdditionalCostValues === undefined ? undefined : ((value.sapAdditionalCostValues as Array<any>).map(SAPAdditionalCostValueToJSON)),
        'sapCustomerFiscalId': SAPFiscalIdToJSON(value.sapCustomerFiscalId),
        'totalOrderDiscounts': PriceToJSON(value.totalOrderDiscounts),
        'comment': value.comment,
        'pakkeboksId': value.pakkeboksId,
        'rekvisition': value.rekvisition,
        'entryCode': value.entryCode,
        'paymentMode': PaymentModeToJSON(value.paymentMode),
        'paymentAddress': AddressToJSON(value.paymentAddress),
        'flexDeliveryComment1': value.flexDeliveryComment1,
        'flexDeliveryComment2': value.flexDeliveryComment2,
        'actingUserId': value.actingUserId,
        'totalUnitCount': value.totalUnitCount,
        'potentialOrderPromotions': value.potentialOrderPromotions === undefined ? undefined : ((value.potentialOrderPromotions as Array<any>).map(PromotionResultToJSON)),
        'potentialProductPromotions': value.potentialProductPromotions === undefined ? undefined : ((value.potentialProductPromotions as Array<any>).map(PromotionResultToJSON)),
        'name': value.name,
        'description': value.description,
        'expirationTime': value.expirationTime === undefined ? undefined : (value.expirationTime.toISOString()),
        'saveTime': value.saveTime === undefined ? undefined : (value.saveTime.toISOString()),
        'savedBy': PrincipalToJSON(value.savedBy),
        'earliestRetrievalAt': value.earliestRetrievalAt,
        '_messages': value.messages === undefined ? undefined : ((value.messages as Array<any>).map(ApiMessageToJSON)),
        '_availableOperations': value.availableOperations === undefined ? undefined : (mapValues(value.availableOperations, AvailableOperationToJSON)),
        'costCenter': B2BCostCenterToJSON(value.costCenter),
        'sapQuote': QuoteToJSON(value.sapQuote),
        'active': value.active,
        'trigger': TriggerToJSON(value.trigger),
        'firstDate': value.firstDate === undefined ? undefined : (value.firstDate.toISOString()),
        'replenishmentOrderCode': value.replenishmentOrderCode,
    };
}

